var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"d-flex justify-center",attrs:{"absolute":"","width":"auto"}},[_c('div',[_c('MadeWithLove')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }